"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableauSheetEvent = void 0;
const TableauEvent_1 = require("./TableauEvent");
class TableauSheetEvent extends TableauEvent_1.TableauEvent {
    get sheet() {
        return this._sheet;
    }
    constructor(type, sheet) {
        super(type);
        this._sheet = sheet;
    }
}
exports.TableauSheetEvent = TableauSheetEvent;
//# sourceMappingURL=TableauSheetEvent.js.map